<nav #header class="fixed-top" style="filter: drop-shadow(1px 1px 1px #6666664d);">
    <div class="containerHeader" style="background-color: white !important;">
        <div style="width: 300px;">
            <a href="https://galapagosisland.net/" target="_blank"><img
                    src="../assets/images/logos-header/ct.svg" class="logo"
                    alt="" style="max-width: 150px; height: auto;" decoding="async"></a>
        </div>
        <div class="kontakt">
            <ul class="navbar-nav">
                <li class="nav-item menuItem"><a href="https://galapagosisland.net/galapagos-cruises/"
                        target="_blank">GALAPAGOS CRUISES & TOURS</a>
                </li>
                <li class="nav-item menuItem"><a href="https://galapagosisland.net/live-availability-galapagos-cruises"
                        target="_blank">CRUISE AVAILABILITY</a>
                </li>
                <li class="nav-item menuItem"><a href="https://galapagosisland.net/galapagos-islands/"
                        target="_blank">GALAPAGOS
                        GUIDE</a>
                </li>
                <li class="nav-item menuItem"><a href="https://galapagosisland.net/reviews/" target="_blank">REVIEWS</a>
                </li>
                <li class="nav-item menuItem"><a href="https://galapagosisland.net/about-us/" target="_blank">
                        <i class="fa fa-user-o user" style="padding-right: 5px;"></i>ABOUT US</a>
                </li>
                <li class="nav-item menuItem" *ngIf="companyParamsService.getFiltersInterest()">
                    <app-heart-header></app-heart-header>
                </li>
            </ul>
            <div class="header-telephone">
                <a href="tel:+18774367512" title="Tel. +1-877-436-7512" style="font-weight: bold; padding: 0 10px;"
                    target="_blank"><i class="fa fa-volume-control-phone"></i>
                    1-877-436-7512</a>
                <a href="https://galapagosisland.net/contact/" title="contact-us" class="contact-us-btn"
                    style="color: white !important;" target="_blank">
                    <i class="fa fa-commenting" style="color: white !important; padding-right: 10px;"></i>
                    CONTACT US</a>
                <a href="https://galapagosisland.net/" title="contact-us" target="_blank"
                    style="display: flex; align-items: center;height: 80px; padding: 0px 30px;">
                    <i class="fa fa-search"
                        style="color: rgb(103, 125, 152) !important; font-size: 13px !important;"></i></a>
            </div>

        </div>
        <a class="menuButton" (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
    </div>
    <ul class="navbar-nav verticalMenu" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://galapagosisland.net/galapagos-cruises/" target="_blank">GALAPAGOS
                CRUISES & TOURS</a>
        </li>
        <li class="nav-item menuItem"><a href="https://galapagosisland.net/live-availability-galapagos-cruises"
                target="_blank">CRUISE AVAILABILITY</a>
        </li>
        <li class="nav-item menuItem"><a href="https://galapagosisland.net/galapagos-islands/" target="_blank">GALAPAGOS
                GUIDE</a>
        </li>
        <li class="nav-item menuItem"><a href="https://galapagosisland.net/reviews/" target="_blank">REVIEWS</a>
        </li>
        <li class="nav-item menuItem"><a href="https://galapagosisland.net/about-us/" target="_blank">
                <i class="fa fa-user-o user" style="padding-right: 5px;"></i>ABOUT US</a>
        </li>
        <li class="nav-item menuItem"> <a href="tel:+187743675120" title="Tel. +1-877-436-7512" target="_blank"><i
                    class="fa fa-volume-control-phone"></i>
                1-877-436-7512</a>
        </li>
        <li class="nav-item menuItem"> <a href="https://galapagosisland.net/contact/" title="contact-us"
                style="letter-spacing: 0px; font-size: 14px;" target="_blank">
                <i class="fa fa-commenting" style="color:white !important;"></i>
                Contact us</a>
        </li>
        <li class="nav-item menuItem" *ngIf="companyParamsService.getFiltersInterest()">
            <app-heart-header></app-heart-header>
        </li>
    </ul>
</nav>